/** Error tipado de la API. `status` 0 = error de red. */
export class ApiError extends Error {
    status;
    code;
    details;
    constructor(status, code, message, details) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
        this.details = details;
    }
    static is(err) {
        return err instanceof ApiError;
    }
}
export function buildQuery(query) {
    if (!query)
        return '';
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
        if (value === undefined || value === null || value === '')
            continue;
        if (Array.isArray(value)) {
            for (const v of value)
                params.append(key, String(v));
        }
        else {
            params.append(key, String(value));
        }
    }
    const s = params.toString();
    return s ? `?${s}` : '';
}
/** Para armar paths con params: `p`/locals/${id}`` escapa cada segmento. */
export function enc(segment) {
    return encodeURIComponent(segment);
}
export function createCoreClient(options) {
    const baseUrl = options.baseUrl.replace(/\/+$/, '');
    const doFetch = options.fetch ?? ((...args) => fetch(...args));
    async function request(method, path, body, opts = {}) {
        const headers = { Accept: 'application/json', ...opts.headers };
        const isForm = typeof FormData !== 'undefined' && body instanceof FormData;
        if (body !== undefined && !isForm)
            headers['Content-Type'] = 'application/json';
        if (!opts.anonymous) {
            const token = options.getToken?.();
            if (token)
                headers.Authorization = `Bearer ${token}`;
        }
        const url = `${baseUrl}${path.startsWith('/') ? path : `/${path}`}${buildQuery(opts.query)}`;
        let res;
        try {
            res = await doFetch(url, {
                method,
                headers,
                body: body === undefined ? undefined : isForm ? body : JSON.stringify(body),
                signal: opts.signal,
            });
        }
        catch (err) {
            if (err instanceof Error && err.name === 'AbortError')
                throw err;
            throw new ApiError(0, 'NETWORK_ERROR', 'No pudimos conectarnos con el servidor', err);
        }
        const contentType = res.headers.get('content-type') ?? '';
        let payload = undefined;
        if (res.status !== 204 && res.status !== 304) {
            const text = await res.text();
            if (text) {
                if (contentType.includes('application/json')) {
                    try {
                        payload = JSON.parse(text);
                    }
                    catch {
                        payload = text;
                    }
                }
                else {
                    payload = text;
                }
            }
        }
        if (!res.ok) {
            const errBody = (payload && typeof payload === 'object' ? payload : {});
            const message = (typeof errBody.message === 'string' && errBody.message) ||
                (typeof payload === 'string' && payload) ||
                res.statusText ||
                'Error inesperado';
            const error = new ApiError(res.status, errBody.code ?? `HTTP_${res.status}`, message, errBody.details);
            if (res.status === 401)
                options.onUnauthorized?.(error);
            throw error;
        }
        return payload;
    }
    return {
        baseUrl,
        request,
        get: (path, opts) => request('GET', path, undefined, opts),
        post: (path, body, opts) => request('POST', path, body, opts),
        put: (path, body, opts) => request('PUT', path, body, opts),
        patch: (path, body, opts) => request('PATCH', path, body, opts),
        delete: (path, opts) => request('DELETE', path, undefined, opts),
    };
}
//# sourceMappingURL=core.js.map